module.exports = __webpack_public_path__ + "img/img-eat-10.e69f8feb.png";